const translations = {
    csv: 'CSV'
};

export default translations;
